import React, { useEffect, useState } from "react";
import "./BackdoorAccess.scss";
import { Description } from "../../../../Global/GlobalText";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../../../Global/GlobalButton";
import { useNavigate } from "react-router-dom";
import { InputLabel, InputType } from "../../../../Global/GlobalFormElement";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { FaCopy } from "react-icons/fa";
import { useSelector } from "react-redux";
import { EXCHNAGE_URL } from "../../../../../Url/Url";
import axios from "axios";
import { toast } from "react-toastify";

export const BackdoorAccess = ({ setSelectedButton }) => {
  const navigate = useNavigate();
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const [backdoorLink, setBackdoorLink] = useState("")
  const token = localStorage.getItem("token")
  const [inputValue, setInputValue] = useState(""); 


  const getBackdoorUrl = async () =>{
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/getBackdoor?eventId=${eventIdGet}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const backdoorURL = response.data.data.event_url
      setInputValue(backdoorURL);
    } catch (error) {
      console.log(error);
    }
  }

  const handleGenerateClick = async () => {
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/createBackdoor?eventId=${eventIdGet}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const backdoorURL = response.data.data.event_url
      setInputValue(backdoorURL);
      toast.success("Backdoor Link created SuccessFully")
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(()=>{
getBackdoorUrl()
  },[eventIdGet,token])

 const handleDeleteUrl = async () => {
 try {
    const response = await axios.delete(
      `${EXCHNAGE_URL}/deleteBackdoor?eventId=${eventIdGet}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    setInputValue("");
    toast.success("Backdoor Link Deleted SuccessFully")
  } catch (error) {
    console.log(error);
  }
};

  const handleCopyClick = () => {
    if (inputValue) {
      navigator.clipboard.writeText(inputValue).then(() => {
        toast.success("Link Copied Successfully.")
      });
    }
  };

  console.log(inputValue)
  

  return (
    <div>
      <form className="newevent_form">
        <div className="submissionid_format">
          <Description>
            You can create a link to give backdoor access to users to allow them
            to submit their works even after
          </Description>
          <Description>
            submission for the event has officially closed.
          </Description>
        </div>

        <div className="backdoorlink_div">
          <InputLabel>Backdoor Link</InputLabel>
          <div className="backdoorlink_input_btn">
          <InputType
              type="text" 
              placeholder="4"
              value={inputValue || ""} 
              readOnly
              onChange={(e) => setInputValue(e.target.value)}   
            />          
              <RedBackgroundButton
              type="button"
            onClick={handleGenerateClick}
            disabled={inputValue}
            >Generate
            </RedBackgroundButton>
            <GreyBorderButton
            type="button"
             onClick={handleCopyClick}
            >
              {" "}
              <FaCopy /> Copy
            </GreyBorderButton>
            <RiDeleteBin6Fill onClick={handleDeleteUrl} />
          </div>
        </div>

        <div className="newevent_btndiv">
          <GreyBorderButton
            onClick={() => {
              navigate(setSelectedButton(3));
            }}
          >
            Cancel
          </GreyBorderButton>

          <RedBackgroundButton
            onClick={() => {
              navigate(setSelectedButton(5));
            }}
          >
            Save
          </RedBackgroundButton>
        </div>
      </form>
    </div>
  );
};
